import type { MapViewState } from "../types";
import { clampView } from "./coordinates";

const prefix = "#map=";

export function encodeMapState(view: MapViewState): string {
  const safe = clampView(view);
  return `${prefix}${safe.lat.toFixed(5)},${safe.lon.toFixed(5)},${safe.zoom.toFixed(2)},${safe.pitch.toFixed(0)},${safe.bearing.toFixed(0)}`;
}

export function parseMapState(hash: string): MapViewState | null {
  if (!hash.startsWith(prefix)) return null;
  const parts = hash.slice(prefix.length).split(",");
  if (parts.length < 4 || parts.length > 5) return null;
  const [lat, lon, zoom, pitch, bearing = "0"] = parts.map(Number);
  if (![lat, lon, zoom, pitch, Number(bearing)].every(Number.isFinite)) return null;
  return clampView({ lat, lon, zoom, pitch, bearing: Number(bearing) });
}
